import {
    FETCH_THIRD_PARTY_APPS_FETCHING,
    FETCH_THIRD_PARTY_APPS_SUCCESS,
    FETCH_THIRD_PARTY_APPS_FAIL,
    REMOVE_THIRD_PARTY_APP,
    DELETE_THIRD_PARTY_APP_DELETING,
    DELETE_THIRD_PARTY_APP_SUCCESS,
    DELETE_THIRD_PARTY_APP_FAIL,
    FETCH_THIRD_PARTY_APPS_PERMISSIONS_FETCHING,
    FETCH_THIRD_PARTY_APPS_PERMISSIONS_SUCCESS,
    FETCH_THIRD_PARTY_APPS_PERMISSIONS_FAIL,
    FETCH_THIRD_PARTY_APPS_CAPABILITIES_FETCHING,
    FETCH_THIRD_PARTY_APPS_CAPABILITIES_SUCCESS,
    FETCH_THIRD_PARTY_APPS_CAPABILITIES_FAIL,
    UPDATE_THIRD_PARTY_APPS_PERMISSIONS_UPDATING,
    UPDATE_THIRD_PARTY_APPS_PERMISSIONS_SUCCESS,
    UPDATE_THIRD_PARTY_APPS_PERMISSIONS_FAIL
} from 'actions/ActionTypes';

import { isImportPermission } from 'utils/thirdPartyApps/ThirdPartyAppsUtil';

export const PERMISSION_TYPES = {
    ALL: 'ALL',
    IMPORT: 'IMPORT',
    EXPORT: 'EXPORT'
};

const INITIAL_STATE = {
    oauthTokens: [],
    oauthTokensFetching: false,
    oauthTokensFetchSuccess: false,
    oauthTokensFetchFail: false,
    oauthTokensDeleting: false,
    oauthTokensDeleteFail: false,
    oauthTokensDeleteSuccess: false,
    partnerPermissions: [],
    partnerPermissionsFetching: false,
    partnerPermissionsFetchSuccess: false,
    partnerPermissionsFetchFail: false,
    capabilities: {},
    capabilitiesFetching: false,
    capabilitiesFetchSuccess: false,
    capabilitiesFetchFail: false,
    partnerPermissionsUpdating: false,
    partnerPermissionsUpdateSuccess: false,
    partnerPermissionsUpdateFail: false
};

// ======= Fetching Handlers =======
const thirdPartyAppsFetching = (state) => {
    return {
        ...state,
        oauthTokensFetching: true,
        oauthTokensFetchSuccess: false,
        oauthTokensFetchFail: false
    };
};

const thirdPartyAppsFetchFinished = (success) => (state, action) => {
    return {
        ...state,
        oauthTokens: success ? action.oauthTokens : state.oauthTokens,
        oauthTokensFetching: false,
        oauthTokensFetchSuccess: success,
        oauthTokensFetchFail: !success
    };
};

const partnerPermissionsFetching = (state) => {
    return {
        ...state,
        partnerPermissionsFetching: true,
        partnerPermissionsFetchSuccess: false,
        partnerPermissionsFetchFail: false
    };
};

const partnerPermissionsFetchFinished = (success) => (state, action) => {
    return {
        ...state,
        partnerPermissions: success ? action.partnerPermissions : state.partnerPermissions,
        partnerPermissionsFetching: false,
        partnerPermissionsFetchSuccess: success,
        partnerPermissionsFetchFail: !success
    };
};

const thirdPartyAppCapabilitiesFetching = (state) => {
    return {
        ...state,
        capabilitiesFetching: true,
        capabilitiesFetchSuccess: false,
        capabilitiesFetchFail: false
    };
};

const thirdPartyAppCapabilitiesFetchFinished = (success) => (state, action) => {
    return {
        ...state,
        capabilities: {
            ...state.capabilities,
            ...(success && { [action.capabilities.consumerKey]: action.capabilities })
        },
        capabilitiesFetching: false,
        capabilitiesFetchSuccess: success,
        capabilitiesFetchFail: !success
    };
};

// ======= Updating Handlers =======

const updatePartnerPermissionsUpdating = (state) => {
    return {
        ...state,
        partnerPermissionsUpdating: true,
        partnerPermissionsUpdateSuccess: false,
        partnerPermissionsUpdateFail: false
    };
};

const updatePartnerPermissionsUpdateFinished = (success) => (state, action) => {
    let partnerPermissions = state.partnerPermissions;
    if (success) {
        let index = partnerPermissions.findIndex(
            (partnerPermission) => partnerPermission.consumerKey === action.partnerPermissions.consumerKey
        );
        if (index === -1 && action.partnerPermissions.permissions.length > 0) {
            // no permission found, insert to array
            partnerPermissions.unshift(action.partnerPermissions);
        } else {
            // replace existing permission
            partnerPermissions[index] = action.partnerPermissions;
            if (action.partnerPermissions.permissions.length < 1) {
                // no permissions left? Remove the object
                partnerPermissions.splice(index, 1);
            }
        }
    }
    return {
        ...state,
        partnerPermissions: partnerPermissions,
        partnerPermissionsUpdating: false,
        partnerPermissionsUpdateSuccess: success,
        partnerPermissionsUpdateFail: !success
    };
};

// ======= Deleting Handlers =======

const deleteThirdPartyAppDeleting = (state) => {
    return {
        ...state,
        oauthTokensDeleting: true,
        oauthTokensDeleteFail: false,
        oauthTokensDeleteSuccess: false
    };
};

const deleteThirdPartyAppDeleteSuccess = (state, action) => {
    const appToDelete = state.oauthTokens.find((oauthToken) => oauthToken.consumerKey === action.consumerKey);

    let partnerPermissions = state.partnerPermissions;
    let index = partnerPermissions.findIndex(
        (partnerPermission) => partnerPermission.consumerKey === appToDelete.consumerKey
    );
    if (index !== -1) {
        // remove permission
        partnerPermissions.splice(index, 1);
    }

    let capabilities = state.capabilities;
    delete capabilities[appToDelete.consumerKey];

    return {
        ...state,
        oauthTokens: state.oauthTokens.filter((oauthToken) => oauthToken.consumerKey !== action.consumerKey),
        oauthTokensDeleting: false,
        oauthTokensDeleteFail: false,
        oauthTokensDeleteSuccess: true,
        capabilities: capabilities,
        partnerPermissions: partnerPermissions
    };
};

const deleteThirdPartyAppDeleteFail = (state) => {
    return {
        ...state,
        oauthTokensDeleting: false,
        oauthTokensDeleteFail: true
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_THIRD_PARTY_APPS_FETCHING]: thirdPartyAppsFetching,
    [FETCH_THIRD_PARTY_APPS_SUCCESS]: thirdPartyAppsFetchFinished(true),
    [FETCH_THIRD_PARTY_APPS_FAIL]: thirdPartyAppsFetchFinished(false),
    [REMOVE_THIRD_PARTY_APP]: deleteThirdPartyAppDeleteSuccess,
    [DELETE_THIRD_PARTY_APP_DELETING]: deleteThirdPartyAppDeleting,
    [DELETE_THIRD_PARTY_APP_SUCCESS]: deleteThirdPartyAppDeleteSuccess,
    [DELETE_THIRD_PARTY_APP_FAIL]: deleteThirdPartyAppDeleteFail,
    [FETCH_THIRD_PARTY_APPS_PERMISSIONS_FETCHING]: partnerPermissionsFetching,
    [FETCH_THIRD_PARTY_APPS_PERMISSIONS_SUCCESS]: partnerPermissionsFetchFinished(true),
    [FETCH_THIRD_PARTY_APPS_PERMISSIONS_FAIL]: partnerPermissionsFetchFinished(false),
    [FETCH_THIRD_PARTY_APPS_CAPABILITIES_FETCHING]: thirdPartyAppCapabilitiesFetching,
    [FETCH_THIRD_PARTY_APPS_CAPABILITIES_SUCCESS]: thirdPartyAppCapabilitiesFetchFinished(true),
    [FETCH_THIRD_PARTY_APPS_CAPABILITIES_FAIL]: thirdPartyAppCapabilitiesFetchFinished(false),
    [UPDATE_THIRD_PARTY_APPS_PERMISSIONS_UPDATING]: updatePartnerPermissionsUpdating,
    [UPDATE_THIRD_PARTY_APPS_PERMISSIONS_SUCCESS]: updatePartnerPermissionsUpdateFinished(true),
    [UPDATE_THIRD_PARTY_APPS_PERMISSIONS_FAIL]: updatePartnerPermissionsUpdateFinished(false)
};

// ======= Default Action =======
export default function thirdPartyApps(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Selectors =======

export const getThirdPartyApps = (state) => {
    return state.thirdPartyApps.oauthTokens;
};

export const isThirdPartyAppsFetching = (state) => {
    return state.thirdPartyApps.oauthTokensFetching;
};

export const didThirdPartyAppsFetchFail = (state) => {
    return state.thirdPartyApps.oauthTokensFetchFail;
};

export const isThirdPartyAppsDeleting = (state) => {
    return state.thirdPartyApps.oauthTokensDeleting;
};

export const didThirdPartyAppsUpdateFail = (state) => {
    return state.thirdPartyApps.oauthTokensDeleteFail;
};

export const didThirdPartyAppsUpdateSucceed = (state) => {
    return state.thirdPartyApps.oauthTokensDeleteSuccess;
};

export const getThirdPartyAppsPermissions = (state) => {
    return state.thirdPartyApps.partnerPermissions;
};

export const isThirdPartyAppsPermissionsFetching = (state) => {
    return state.thirdPartyApps.partnerPermissionsFetching;
};

/**
 * Get third party user applicable app capabilities. Optional: filter by permission type (IMPORT or EXPORT)
 * @param {*} state
 * @param {*} consumerKey
 * @param {*} type
 * @returns
 */
export const getThirdPartyAppCapabilities = (state, consumerKey, type) => {
    const permissionType = PERMISSION_TYPES[type];
    const capabilities = state.thirdPartyApps.capabilities[consumerKey] || {};
    if (!capabilities.capabilities) {
        return [];
    }
    // remove user inapplicable capabilities
    const userApplicableCapabilities = capabilities.capabilities.filter(
        (capability) =>
            !capabilities.userInapplicableCapabilities ||
            (capabilities.userInapplicableCapabilities &&
                capabilities.userInapplicableCapabilities.indexOf(capability.consumerCapability) === -1)
    );
    if (permissionType === PERMISSION_TYPES.IMPORT) {
        const filteredCapabilities = userApplicableCapabilities.filter((capability) =>
            isImportPermission(capability.consumerCapability)
        );
        return filteredCapabilities;
    }
    if (permissionType === PERMISSION_TYPES.EXPORT) {
        const filteredCapabilities = userApplicableCapabilities.filter(
            (capability) => !isImportPermission(capability.consumerCapability)
        );
        return filteredCapabilities;
    }

    return userApplicableCapabilities;
};

export const isThirdPartyAppCapabilitiesFetching = (state) => {
    return state.thirdPartyApps.capabilitiesFetching;
};

export const getThirdPartyAppPermissions = (state, consumerKey) => {
    return state.thirdPartyApps.partnerPermissions.find((permission) => permission.consumerKey === consumerKey);
};

export const hasThirdPartyAppPermission = (state, consumerKey, capability) => {
    if (!consumerKey || !capability) {
        throw new Error('consumerKey and capability required.');
    }
    const permissions = state.thirdPartyApps.partnerPermissions.find(
        (permission) => permission.consumerKey === consumerKey
    );
    return !!(permissions && permissions.permissions.includes(capability));
};

export const getUserInapplicableCapabilities = (state, consumerKey) => {
    return state.thirdPartyApps.capabilities[consumerKey].userInapplicableCapabilities;
};
